var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArcImg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 17.3334H1.33333C1.11232 17.3334 0.900358 17.2456 0.744078 17.0893C0.587797 16.9331 0.5 16.7211 0.5 16.5001V1.50008C0.5 1.27907 0.587797 1.06711 0.744078 0.910826C0.900358 0.754545 1.11232 0.666748 1.33333 0.666748H14.6667C14.8877 0.666748 15.0996 0.754545 15.2559 0.910826C15.4122 1.06711 15.5 1.27907 15.5 1.50008V16.5001C15.5 16.7211 15.4122 16.9331 15.2559 17.0893C15.0996 17.2456 14.8877 17.3334 14.6667 17.3334ZM13.8333 15.6667V2.33341H2.16667V15.6667H13.8333ZM4.66667 4.83342H11.3333V6.50008H4.66667V4.83342ZM4.66667 8.16675H11.3333V9.83342H4.66667V8.16675ZM4.66667 11.5001H8.83333V13.1667H4.66667V11.5001Z",
    fill: "#0290E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcImg4);
export default __webpack_public_path__ + "static/media/arc-img-4.abf338d8e6eb9547479475c53836cb95.svg";
export { ForwardRef as ReactComponent };